import { AxiosResponse } from 'axios';
import axios from './api';

import {
  GetApplicationUnionListResponse,
  GetApplicationIndustryListResponse,
  CreateMyApplicationInput,
  MyApplication,
  GetApplicationSchoolListResponse,
  GetMyApplicationListResponse,
  GetApplicationEducationIndustryListResponse,
  GetApplicationEducationOtherListResponse,
  GetApplicationEducationCourseListResponse,
  GetApplicationJobListResponse,
} from './application.types';

export type {
  GetApplicationUnionListResponse,
  GetApplicationIndustryListResponse,
  GetApplicationSchoolListResponse,
  GetMyApplicationListResponse,
  MyApplication,
  GetApplicationEducationIndustryListResponse,
  GetApplicationEducationOtherListResponse,
  GetApplicationEducationCourseListResponse,
  GetApplicationJobListResponse,
};

/*
 * Sækja yfirlit yfir stéttarfélög
 */
export const getApplicationUnionList = (): Promise<AxiosResponse<GetApplicationUnionListResponse[]>> => {
  return axios.get('/application-v1/application/application-union/');
};

/*
 * Sækja yfirlit yfir iðngreinar
 */
export const getApplicationIndustryList = (): Promise<AxiosResponse<GetApplicationIndustryListResponse[]>> => {
  return axios.get('/application-v1/application/application-industry/');
};

/*
 * Sækja yfirlit yfir skóla
 */
export const getApplicationSchoolList = (): Promise<AxiosResponse<GetApplicationSchoolListResponse[]>> => {
  return axios.get('/application-v1/application/application-school/');
};

/*
 * Sækja yfirlit yfir sveinsprófsgreinar
 */
export const getApplicationEducationIndustryList = (): Promise<AxiosResponse<GetApplicationEducationIndustryListResponse[]>> => {
  return axios.get('/application-v1/application/application-education-industry/');
};

/*
 * Sækja yfirlit yfir aðrar greinar
 */
export const getApplicationEducationOtherList = (): Promise<AxiosResponse<GetApplicationEducationOtherListResponse[]>> => {
  return axios.get('/application-v1/application/application-education-other/');
};

/*
 * Sækja yfirlit yfir námskeið
 */
export const getApplicationEducationCourseList = (): Promise<AxiosResponse<GetApplicationEducationCourseListResponse[]>> => {
  return axios.get('/application-v1/application/application-education-course/');
};

/*
 * Sækja yfirlit yfir störf
 */
export const getApplicationJobList = (): Promise<AxiosResponse<GetApplicationJobListResponse[]>> => {
  return axios.get('/application-v1/application/application-job/');
};

/*
 * Sækja yfirlit yfir umsóknir
 */
export const getMyApplicationList = (): Promise<AxiosResponse<GetMyApplicationListResponse[]>> => {
  return axios.get('/application-v1/application/my-application/');
};

/*
 * Skrá nýja umsókn
 */
export const createMyApplication = (data: CreateMyApplicationInput): Promise<AxiosResponse<MyApplication>> => {
  return axios.post('/application-v1/application/my-application/', data);
};
